import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Wed, 26 Jul 2024 8:18PM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.-iECibpyG8ggD7_tDQ5bMjbIiQNmtZl5a2eGO1hqlf0frlM_CL2Zg8P4gVQ8JW9vZxiR7rSJ-ugr0ppDojWNDtAHzs5ZOzWszlqeOul6nf3eAITEEokZooPvbrSZKT-xU49ns5o17wct-dz7BIJHJR__Jf2RZzH84oG5mfp57-c5e03q7aqewsEvWwa8sn8O4_PWDazgMlIxs0KLuxFcpUwqbDI1gOIguxg_80Uft0QbSEI2UIFarVzui5rLuiHa-ZWbimmYW8wsyCGJo9wAYf9CMbP7PgM",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-08-02T23:17:30.836205Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2024-07-26T23:17:19+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.-iECibpyG8ggD7_tDQ5bMjbIiQNmtZl5a2eGO1hqlf0frlM_CL2Zg8P4gVQ8JW9vZxiR7rSJ-ugr0ppDojWNDtAHzs5ZOzWszlqeOul6nf3eAITEEokZooPvbrSZKT-xU49ns5o17wct-dz7BIJHJR__Jf2RZzH84oG5mfp57-c5e03q7aqewsEvWwa8sn8O4_PWDazgMlIxs0KLuxFcpUwqbDI1gOIguxg_80Uft0QbSEI2UIFarVzui5rLuiHa-ZWbimmYW8wsyCGJo9wAYf9CMbP7PgM'

// {
//   "access_token": "v2.local.mHSJkhsWVaUHn-0nSfpFH_BGq1chEtSbP5zs9DvvmSHNjq2InLoOkL7E_sN2IinU7PDPvNkqiiG8P-kAqW_1iyEnP5nJtF-BWEFNIMwdOOP3Iuph0i0geQzqhMmLWQHnt-P2SgGfcA9LA3noeUaAZupTcLyNf-f6NLm8ye-3TDGzVnXXKEp4G0p4FxI7igZxy156IGit3463WfRqylHDojbPMVLy0HyqKV4LLhCduMmFWZ2rVhhOUTqFf7pJMjXKQkf_xl9LZTskhZNDABR5kHtTd7qOZWw",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-08-02T23:19:41.335113Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2024-07-26T23:19:36+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.mHSJkhsWVaUHn-0nSfpFH_BGq1chEtSbP5zs9DvvmSHNjq2InLoOkL7E_sN2IinU7PDPvNkqiiG8P-kAqW_1iyEnP5nJtF-BWEFNIMwdOOP3Iuph0i0geQzqhMmLWQHnt-P2SgGfcA9LA3noeUaAZupTcLyNf-f6NLm8ye-3TDGzVnXXKEp4G0p4FxI7igZxy156IGit3463WfRqylHDojbPMVLy0HyqKV4LLhCduMmFWZ2rVhhOUTqFf7pJMjXKQkf_xl9LZTskhZNDABR5kHtTd7qOZWw'

// {
//   "access_token": "v2.local.Rb0IA1uTfe4IiflWindmOU-gpqkaAc-wrtUH3SKn6oTSUzcET0Ljs5QBfbD1T8FXHtDFIYsWB-YOcv2Djvl8RPOAoNjeul4JEbtdAxwRd7eBneZRXASybJ_aq72X7B4XuhF_ChILpZ7RMtLveBMQ12AB54SF-7QKsMqbS7nMH78myy47CYpH-9Q0QUknsd1fYg9Nt9JbdW3Y5WcuQkj0xdlxI1W7xN29EdV8i286i0c-R1Uh1Jx11QEawIVmwKICK2uYrfVJxv0_WtcHnlsUz94IA1aH",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-08-02T23:22:35.463324Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.Rb0IA1uTfe4IiflWindmOU-gpqkaAc-wrtUH3SKn6oTSUzcET0Ljs5QBfbD1T8FXHtDFIYsWB-YOcv2Djvl8RPOAoNjeul4JEbtdAxwRd7eBneZRXASybJ_aq72X7B4XuhF_ChILpZ7RMtLveBMQ12AB54SF-7QKsMqbS7nMH78myy47CYpH-9Q0QUknsd1fYg9Nt9JbdW3Y5WcuQkj0xdlxI1W7xN29EdV8i286i0c-R1Uh1Jx11QEawIVmwKICK2uYrfVJxv0_WtcHnlsUz94IA1aH'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
